import http from "./http";
export default (sellerId) => ({
  async index(filters) {
    return http
      .index("sells", filters)
      .then((json) => ({ sells: json }))
      .catch(async (e) => ({ sells: null, error: await e }));
  },
  async get() {
    return http
      .get("sells", sellerId)
      .then((json) => ({ seller: json }))
      .catch(async (e) => ({ seller: null, error: await e }));
  },
  async create(data) {
    return http
      .post("sells", data)
      .then((json) => ({ seller: json }))
      .catch(async (e) => ({ seller: null, error: await e }));
  },
  async update(data) {
    return http
      .put("sells", sellerId, data)
      .then((json) => ({ seller: json }))
      .catch(async (e) => ({ seller: null, error: await e }));
  },
  async delete() {
    return http
      .delete("sells", sellerId)
      .then((json) => ({ seller: json }))
      .catch(async (e) => ({ seller: null, error: await e }));
  },
  async aggregate(filters) {
    return http
      .index("sells/aggregate", filters)
      .then((json) => ({ aggregation: json }))
      .catch(async (e) => ({ aggregation: null, error: await e }));
  },
});
